class VatRateController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'vatRate',
		'VatRateRepository',
		'ConfigurationService',

	initialize: ->
		@mainCrud.entityType = 'general.vatrate'
		@mainCrud.showDelete = @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateDeletion'

		if @mainCrud.isNewEntity
			@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateCreation'
		else
		@enableVatRateLabel = @ConfigurationService.isEnabled 'Backoffice.Setting.VatRateLabelMandatory.Enabled'

		if @vatRate.id
			@mainCrud.entityTitle = @vatRate.name
			@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateEdit'
			@mainCrud.isNewEntity = false

			@vatRate.percentageText = @VatRateRepository.getPercentageText(@vatRate.percentage)

			if @enableVatRateLabel && _.isEmpty @vatRate.label
				@vatRate.label = @vatRate.name.charAt(0).toUpperCase()

			if !_.isEmpty @vatRate.price_region
				@mainCrud.afterHeaderTitle = @translate('general.vat.rate.is.default')
		else
			@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.VatRateManagement.EnableVatRateCreation'
			@mainCrud.entityTitle = 'wbo.new.vatrate'
			@mainCrud.isNewEntity = true

	save: ->
		@vatRate.percentage = parseFloat(@vatRate.percentageText / 100).toFixed(5).replace(", ", ".")
		delete @vatRate.percentageText
		tempPriceRegion = @vatRate.price_region
		delete @vatRate.price_region

		@VatRateRepository
			.save @vatRate, @mainCrud.isNewEntity
			.then (response) =>
				@vatRate.percentageText = @VatRateRepository.getPercentageText(response.data.percentage)
				response.data.percentageText = @vatRate.percentageText
				@vatRate.price_region = tempPriceRegion if !@mainCrud.isNewEntity
				@afterSave response
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @VatRateRepository, @vatRate
